<template>
    <figure>
        <v-zoomer style="width: 100%; height: 100%;">
            <img
                :src="responsiveImagesLarge"
                style="object-fit: contain; width: 100%; height: 100%; cursor: zoom-in;"
            >
        </v-zoomer>
    </figure>
</template>

<script>
    import cdn from '@23g/cdn-helper';

    export default {
        name: 'ImageModalItem',
        props: {
            item: {
                type: Object,
                default: () => {},
            },
        },
        computed: {
            responsiveImagesLarge() {
                return cdn(this.item.url, 'h2000');
            },

            responsiveImagesSmall() {
                return cdn(this.item.url, 'h1440');
            },
        },
    };
</script>
